import { Button } from 'components/Button/Button';
import { colors } from 'styles';
import { H4 } from '../../styles/FontStyles';
import { Div } from '../../styles/Styles';
import { useAppDispatch } from 'app/hooks';
import { cancelPayment } from 'services/auth/packages.service';
import { useNavigate } from 'react-router';
import { removeUserFromState } from 'slices';

interface LogoutProps {
  setIsOpen: any;
}

export const Logout = ({ setIsOpen }: LogoutProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <>
      <Div $flex $column $center>
        <H4 center color={colors.white} mb='40' mbSM='20' mt='20' mtSM='20'>
          Are you sure?
        </H4>
        <Div $width='100%' $flex $between $gap='20px'>
          <Button $white onClick={() => setIsOpen(false)}>
            No
          </Button>
          <Button
            onClick={() => {
              navigate('/auth/signin');
              dispatch(removeUserFromState());
            }}
          >
            Yes
          </Button>
        </Div>
      </Div>
    </>
  );
};
